module.exports = __webpack_public_path__ + "img/002.a3cdad01.jpg";